module.exports = __webpack_public_path__ + "static/img/paleberry_64.33c1258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paleberry_64.png
// module id = gAD1
// module chunks = 0